module.exports = function () {
  var html = "\n      <div class=\"naval-movement-overlay\" id=\"naval-movement-overlay\">\n\t<div class=\"origin\">\n          <div class=\"sstatus\"></div>\n          <div class=\"scontrols\"></div>\n\t</div>\n\t<div class=\"destination\">\n          <div class=\"dcontrols\"></div>\n        </div>\n      </div>\n  ";
  return html;
};